import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ClientMediaTemplateAspectRatioRuleId = Brand<number, 'ClientMediaTemplateAspectRatioRuleId'>;
export const ClientMediaTemplateAspectRatioRuleId = createBranded<ClientMediaTemplateAspectRatioRuleId>();
